class PlanSelector {
  
  selected_plan=null;
  selected_variant=null;
  plan_duration=null;
  plan_type=null;

  constructor() {
    var query_string = window.location.href.toLowerCase().split("#")[1];
    if (!query_string) {
      this.selected_plan = window.plan_details.find(plan=>plan.handle=='signature-program' && plan.duration == '7 Days' && plan.type == 'Full Program' && plan.snacks == 0);
    } else {
      var plan_requested = query_string.split("&")[0];
      var variant_requested = query_string.split("&")[1];
      var duration = "";
      var type = "";
      if (variant_requested) {
        var meals_requested = variant_requested.split("_")[0];
        if (meals_requested == "ld") {
          type = "Lunches & Dinners";
        } else {
          type = "Full Program";
        }
        var days_requested = variant_requested.split("_")[1];
        if (days_requested == "5") {
          duration = "5 Days";
        } else {
          duration = "7 Days";
        }
        this.selected_plan = window.plan_details.find(plan=>plan.handle==plan_requested && plan.duration == duration && plan.type == type && plan.snacks == 0);
      } else {
        const plan_type = plan_requested == "vegan-program" ? 'Lunches & Dinners' : 'Full Program';
        this.selected_plan = window.plan_details.find(plan=>plan.handle==plan_requested && plan.duration == '7 Days' && plan.type == plan_type && plan.snacks == 0);
      }
    }
    if (!this.selected_plan) {
      this.selected_plan = window.plan_details[0];
    }
    this.selected_variant = this.selected_plan.id;
    this.plan_duration  = this.selected_plan.duration;
    this.plan_type  = this.selected_plan.type;
    this.plan_snacks = this.selected_plan.snacks;
    this.setupEvents();
    this.render();
  }
  setupEvents() {
    document.querySelectorAll(".single-plan-product").forEach(prog=>{
      prog.addEventListener("click",()=>{
        this.select_program(parseInt(prog.getAttribute("data-product-id")));
        var url = "#" + prog.getAttribute("data-handle");
        window.history.pushState({}, '', url);
      });
    });

    document.querySelectorAll(".variant-option[name='length']").forEach(radio=>{
      radio.addEventListener("click",event=>{
        this.update_duration(event.target.value);
      });
    });

    document.querySelectorAll(".variant-option[name='type']").forEach(radio=>{
      radio.addEventListener("click",event=>{
        this.update_type(event.target.value);
      });
    });

    document.querySelectorAll(".variant-option[name='type'][value='Full Program']").forEach(radio=>{
      radio.addEventListener("click",this.check_type.bind(this));
      radio.nextElementSibling?.addEventListener("mouseenter",this.check_type.bind(this));
      radio.nextElementSibling?.addEventListener("mouseleave",this.check_type.bind(this));
    });

    document.querySelectorAll(".variant-option[name='snacks']").forEach(input=>{
      input.addEventListener("click",async event=>{
        event.preventDefault();
        document.getElementById('decline-snacks-btn').classList.add('button--loading');

        this.update_snacks(event.target.value);

        let addToCartForm = document.querySelector("form[action$='/cart/add']");
        let formData = new FormData(addToCartForm);

        await this.clear_cart();
        await this.add_to_cart(formData);

        const returnToUrl = formData.get("return_to") || "/checkout";
        window.location.href = returnToUrl;
      });
    });

    document.getElementById('select-plan-btn').addEventListener("click", async event => {
      event.preventDefault();
      if (window.snack_upsell_disabled || this.selected_plan.handle == 'vegan-program') {
        event.currentTarget.classList.add('button--loading');

        let addToCartForm = document.querySelector("form[action$='/cart/add']");
        let formData = new FormData(addToCartForm);

        await this.clear_cart();
        await this.add_to_cart(formData);

        const returnToUrl = formData.get("return_to") || "/checkout";
        window.location.href = returnToUrl;
      } else {
        document.querySelectorAll('.js-plan-step').forEach(el => {
          el.classList.remove('active');
        });
        document.querySelectorAll('.js-snack-step').forEach(el => {
          el.classList.add('active');
        });
        document.getElementById('order-anchor').scrollIntoView();
      }
    });

    document.getElementById('decline-snacks-btn').addEventListener("click", async event => {
      event.preventDefault();
      event.currentTarget.classList.add('button--loading');

      let addToCartForm = document.querySelector("form[action$='/cart/add']");
      let formData = new FormData(addToCartForm);

      await this.clear_cart();
      await this.add_to_cart(formData);

      const returnToUrl = formData.get("return_to") || "/checkout";
      window.location.href = returnToUrl;
    });

    document.getElementById('back-to-plan-btn').addEventListener("click", () => {
      document.querySelectorAll('.js-plan-step').forEach(el => {
        el.classList.add('active');
      });
      document.querySelectorAll('.js-snack-step').forEach(el => {
        el.classList.remove('active');
      });
      document.getElementById('order-anchor').scrollIntoView();
    });
  }
  render() {
    document.querySelectorAll(".single-plan-product").forEach(prog=>{
      if (prog.getAttribute("data-product-id")==this.selected_plan.plan_id) {
        prog.setAttribute("checked","")
        prog.classList.add("checked");
        document.querySelector(".js-prod-description").innerHTML = prog.getAttribute("data-description");
      } else {
        prog.removeAttribute("checked");
        prog.classList.remove("checked");
      }
    });

    document.querySelectorAll(".variant-option[name='length']").forEach(radio=>{
      if (radio.value==this.plan_duration) {
        radio.setAttribute("checked","");
        radio.classList.add("checked");
      } else {
        radio.removeAttribute("checked");
        radio.classList.remove("checked");
      }
    });

    document.querySelectorAll(".variant-option[name='type']").forEach(radio=>{
      if (radio.value==this.plan_type) {
        radio.setAttribute("checked","");
        radio.classList.add("checked");
      } else {
        radio.removeAttribute("checked");
        radio.classList.remove("checked");
      }
    });

    let opt = document.querySelector('.variant-option[value="Full Program"]');
    let col = opt?.closest('.d-flex');
    if (this.selected_plan.handle == 'vegan-program') {
      col.classList.add('unavailable');
    } else {
      col.classList.remove('unavailable');
    }

    console.log(this);

    let snack2Plan = window.plan_details.find(plan => plan.plan_id == this.selected_plan.plan_id && plan.meals == this.selected_plan.meals && plan.duration == this.selected_plan.duration && plan.snacks == 2);
    let snack2PriceBefore = snack2Plan?.compare_at - this.selected_plan.compare_at;
    let snack2PriceAfter = snack2Plan?.price - this.selected_plan.price;

    let snack3Plan = window.plan_details.find(plan => plan.plan_id == this.selected_plan.plan_id && plan.meals == this.selected_plan.meals && plan.duration == this.selected_plan.duration && plan.snacks == 3);
    let snack3PriceBefore = snack3Plan?.compare_at - this.selected_plan.compare_at;
    let snack3PriceAfter = snack3Plan?.price - this.selected_plan.price;

    document.querySelector(".js-plan-id").value=this.selected_plan.plan_id;
    document.querySelector(".js-variant-id").value=this.selected_plan.id;
    if (this.plan_snacks == 0) {
      document.querySelector(".weekly-total").innerHTML = `$${this.selected_plan.compare_at.toFixed(2)}`;
      document.querySelector(".compare-price").innerHTML = `$${this.selected_plan.compare_at.toFixed(2)}`;
      document.querySelector(".per-meal-before").innerHTML = `$${this.selected_plan.price_per_meal_before.toFixed(2)}`;
      document.querySelector(".per-meal-after").innerHTML = `$${this.selected_plan.price_per_meal_after.toFixed(2)}`;
      document.querySelector(".program-price").innerHTML = `$${this.selected_plan.price.toFixed(2)}`;
      document.querySelector(".program-price-savings").innerHTML = `$${this.selected_plan.savings.toFixed(2)}`;
      document.querySelector(".plan-includes").innerHTML = this.selected_plan.includes;
      document.querySelector("input#selling_plan").value = this.selected_plan.selling_plan_id;
      document.querySelector(".js-snack-count-2").innerHTML = this.selected_plan.duration == "5 Days" ? "10" : "14";
      document.querySelector(".js-snack-count-3").innerHTML = this.selected_plan.duration == "5 Days" ? "15" : "21";
      document.querySelector(".js-compare-at-snack-price-2").innerHTML = snack2PriceBefore.toFixed(2);
      document.querySelector(".js-new-snack-price-2").innerHTML = snack2PriceAfter.toFixed(2);
      document.querySelector(".js-compare-at-snack-price-3").innerHTML = snack3PriceBefore.toFixed(2);
      document.querySelector(".js-new-snack-price-3").innerHTML = snack3PriceAfter.toFixed(2);
    }
    //document.querySelector(".js-go-cart-add-to-cart").setAttribute('data-sku', this.selected_plan.sku);
    //document.querySelector(".js-go-cart-add-to-cart").setAttribute('data-price', this.selected_plan.price);
  }
  select_program(id) {
    let is_vegan = window.plan_details.some(p => p.plan_id == id && p.handle == 'vegan-program');
    this.plan_type = is_vegan && this.plan_type == 'Full Program' ? 'Lunches & Dinners' : this.plan_type;
         
    this.selected_plan = window.plan_details.find(program=>{
      return program.plan_id == id 
        && program.type == this.plan_type 
        && program.duration == this.plan_duration 
        && program.snacks == this.plan_snacks
    });
    this.selected_variant = this.selected_plan.id;
    this.render();
  }
  update_duration(d) {
    this.plan_duration = d;
    this.select_program(this.selected_plan.plan_id);
  }
  update_type(d) {
    this.plan_type = d;
    let col = document.querySelector('.variant-option[value="'+d+'"]')?.closest('.d-flex');
    this.select_program(this.selected_plan.plan_id);
  }
  update_snacks(d) {
    this.plan_snacks = d;
    this.select_program(this.selected_plan.plan_id);
  }
  async clear_cart() {
    try {
      const result = await fetch(window.Shopify.routes.root + 'cart/clear.js', {
        method: 'POST',
      });
      return result.json();
    }
    catch(error) {
      console.error('Error:', error);
    }
  }
  async add_to_cart(formData) {
    try {
      const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        body: formData
      })
      return response.json();
    }
    catch(error) {
      console.error('Error:', error);
    }
  }
  check_type(e){
    let type = e.srcElement.value || e.srcElement.previousElementSibling?.value;
    if(type != 'Full Program') return;
    let is_vegan = window.plan_details.some(p => p.plan_id==this.selected_plan.plan_id && p.handle == 'vegan-program');
    if(is_vegan && ['mouseenter', 'click'].includes(e.type)){
      document.querySelector(".js-prod-description").innerHTML = 'This option is currently unavailable.';
    } else {
      let prog = document.querySelector(".single-plan-product[data-product-id='"+this.selected_plan.plan_id+"']");
      document.querySelector(".js-prod-description").innerHTML = prog?.getAttribute("data-description")||'';
    }
  }
}
window.addEventListener("DOMContentLoaded",event=>{
	const selector = new PlanSelector();
});
